
export enum InspectionStateEnum {
    None = 0,
    Valid = 1,
    Expiring = 2,
    Required = 3,
    WillRequire = 4
}